module.exports = __webpack_public_path__ + "media/images/pages/primary-teachers/code-club-card-586b7d2cbd33f35a30d9353936c67e7d.svg";